import MuiDivider from '@mui/material/Divider'
import type { SxProps, Theme } from '@mui/material'
import type { ReactNode } from 'react'

export type DividerProps = {
  size?: 'fullWidth' | 'padding'
  orientation?: 'horizontal' | 'vertical'
  decorative?: boolean
  children?: ReactNode
  sx?: SxProps<Theme>
  'data-testid'?: string
}

export const Divider = ({
  size = 'fullWidth',
  orientation = 'horizontal',
  decorative = false,
  children,
  sx,
  'data-testid': dataTestId,
}: DividerProps) => (
  <MuiDivider
    orientation={orientation}
    flexItem={orientation === 'vertical'}
    aria-hidden={decorative || undefined}
    data-testid={dataTestId}
    sx={[
      size === 'padding' &&
        (orientation === 'horizontal' ? { mx: 2 } : { my: 2 }),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </MuiDivider>
)
